const _ = require('lodash');
const { serializeError } = require('serialize-error');
const { obfuscateLog } = require('./obfuscate');
const errorKeys = require('./errorKeys');

const checkValidJson = propValue => {
  if (!_.isString(propValue)) {
    return false;
  }
  try {
    const value = JSON.parse(propValue);
    if (!_.isObject(value)) {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
};
const modifyLogInfo = (objParam, prop, isValidJson) => {
  const obj = objParam;
  if (isValidJson) {
    obj[prop] = JSON.parse(obj[prop]);
  } else if (errorKeys.includes(prop) && _.isString(obj[prop])) {
    obj[`${prop}Message`] = obj[prop];
    delete obj[prop];
  } else if (errorKeys.includes(prop) && _.isInteger(obj[prop])) {
    obj[`${prop}Code`] = obj[prop];
    delete obj[prop];
  } else if (/^\d+$/.test(prop)) {
    // TODO: Need to remove this check after getting a fix for logs parsed with key as a number from logdna
    obj[`_${prop}`] = obj[prop];
    delete obj[prop];
  }
};
const modifyAndObfuscateLog = objParam => {
  const obj = objParam;
  Object.keys(obj).forEach(prop => {
    if (_.isObject(obj[prop])) {
      if (obj[prop] instanceof Error) {
        obj[prop] = serializeError(obj[prop]);
      }
      modifyAndObfuscateLog(obj[prop]);
    } else {
      const isValidJson = checkValidJson(obj[prop]);
      modifyLogInfo(obj, prop, isValidJson);
      if (isValidJson) {
        modifyAndObfuscateLog(obj[prop]);
      }
    }
    obfuscateLog(obj, prop);
  });
  return obj;
};

module.exports = obj => (modifyAndObfuscateLog(_.cloneDeep(obj)));
